import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FeatherModule } from 'angular-feather';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-no-changes-modal',
  templateUrl: './no-changes-modal.component.html',
  imports: [FeatherModule, TranslatePipe],
})
export class NoChangesModalComponent {
  readonly activeModal = inject(NgbActiveModal);

  currentlyReceiving = true;
}
